module.exports = __webpack_public_path__ + "static/media/for-investors-third@3x.bec3c5b2.jpg";